import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "De basisindeling van uw nieuwbouwwoning staat vastgelegd in de verkoopbrochure en de technische omschrijving. Het kan natuurlijk zo zijn, dat deze indeling niet geheel aansluit op uw ideeën over een praktische inrichting.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "U kunt de basisindeling van uw badkamer en toiletruimte nog aanpassen naar uw woonwensen door te kiezen voor inrichten of casco. Als u kiest voor het inrichten van uw badkamer en toiletruimte, dan is deze direct gebruiksklaar. Hierdoor kan de woning eerder in gebruik worden genomen. Uw badkamer en toiletruimte worden standaard ingericht met sanitair van het merk Villeroy & Boch en hoogwaardige kranen van het merk Grohe. Kiest u voor het inrichten van uw badkamer en toiletruimte, dan worden alle inrichtingsmogelijkheden aan u getoond.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Kiest u voor een casco oplevering, dan houdt dit in dat alleen de elektra en het mv-punt aanwezig zijn. De leidingen worden afgedopt op de standaard posities. De inrichtingsmogelijkheden op het gebied van sanitair worden dan ook niet aan u getoond.", -1)

import Completion1OptionsGrid from '@/components/completion1/Completion1OptionsGrid.vue'
import SubtotalWidget from '@/components/SubtotalWidget.vue'
import SubtotalMobileWidget from '@/components/SubtotalMobileWidget.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted } from 'vue'
import { generalStore } from '@/stores/general'
import { headerStore } from '@/stores/header'
import { authStore } from '@/stores/auth'
import { completionOneStore } from '@/stores/completionOne'
import UnityWidget from '@/components/dashboard/UnityWidget.vue'
import SecureLS from 'secure-ls'


export default /*#__PURE__*/_defineComponent({
  __name: 'Completion1',
  setup(__props) {

const router = useRouter()
const ls = new SecureLS({ isCompression: false })
const building = computed(() => ls.get('building'))

onMounted(() => {
  completionOneStore().getPhaseState()
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,4] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 18}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, { title: "Afbouw 1 opties" }, {
            extra: _withCtx(() => [
              (_unref(building)?.unity_enabled && _unref(building)?.model_available)
                ? (_openBlock(), _createBlock(UnityWidget, {
                    key: 0,
                    style: { marginRight: '8px' }
                  }))
                : _createCommentVNode("", true),
              (_unref(generalStore)().desktop)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Dashboard' })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Terug naar dashboard")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              (['loading', 'test', 'demo', 'closed'].includes(_unref(completionOneStore)().phaseState) || _unref(authStore)().demoEnvironment)
                ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          (_unref(completionOneStore)().phaseState === 'loading')
                            ? (_openBlock(), _createBlock(_component_a_skeleton, {
                                key: 0,
                                active: ""
                              }))
                            : _createCommentVNode("", true),
                          (_unref(completionOneStore)().phaseState === 'test' && !_unref(completionOneStore)().isInternalTestAccount)
                            ? (_openBlock(), _createBlock(_component_a_alert, {
                                key: 1,
                                type: "info",
                                message: "Er zijn voor deze fase (nog) geen opties beschikbaar.",
                                description: "Deze opties worden op een later moment zichtbaar.",
                                "show-icon": ""
                              }))
                            : _createCommentVNode("", true),
                          (_unref(completionOneStore)().phaseState === 'demo' || _unref(authStore)().demoEnvironment)
                            ? (_openBlock(), _createBlock(_component_a_alert, {
                                key: 2,
                                type: "info",
                                message: "U bevindt zich in de demo omgeving.",
                                description: "U kunt (nog) geen definitieve bestelling plaatsen voor deze fase.",
                                "show-icon": ""
                              }))
                            : _createCommentVNode("", true),
                          (_unref(completionOneStore)().phaseState === 'closed' && _unref(headerStore)().ordersReceived.completion && !_unref(authStore)().demoEnvironment)
                            ? (_openBlock(), _createBlock(_component_a_alert, {
                                key: 3,
                                type: "success",
                                message: "Bestelling succesvol ontvangen.",
                                "show-icon": ""
                              }, {
                                description: _withCtx(() => [
                                  _createTextVNode(" Wij hebben uw bestelling voor de afbouw opties succesvol ontvangen."),
                                  _hoisted_1,
                                  _createTextVNode(" Het is niet meer mogelijk om uw afbouw opties te wijzigen. Dit is om de voortgang van het bouwproces te continueren. ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_unref(completionOneStore)().phaseState === 'closed' && !_unref(headerStore)().ordersReceived.completion && !_unref(authStore)().demoEnvironment)
                            ? (_openBlock(), _createBlock(_component_a_alert, {
                                key: 4,
                                type: "error",
                                message: "Deze fase is gesloten maar wij hebben geen bestelling ontvangen!",
                                "show-icon": ""
                              }, {
                                description: _withCtx(() => [
                                  _createTextVNode(" Neem zo spoedig mogelijk contact op met Hofzicht Makelaars via telefoonnummer 0252 - 530119. ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(completionOneStore)().phaseState !== 'loading')
                ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _hoisted_2,
                          _hoisted_3,
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      (!['loading', 'test'].includes(_unref(completionOneStore)().phaseState) || (_unref(completionOneStore)().phaseState === 'test' && _unref(completionOneStore)().isInternalTestAccount))
                        ? (_openBlock(), _createBlock(Completion1OptionsGrid, { key: 0 }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { class: "no-mb" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        style: _normalizeStyle(_unref(generalStore)().desktop ? { float: 'right' } : { width: '100%' }),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'Completion2' })))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Naar afbouw 2")
                        ]),
                        _: 1
                      }, 8, ["style"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_unref(generalStore)().desktop)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            span: 6
          }, {
            default: _withCtx(() => [
              _createVNode(SubtotalWidget)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_unref(generalStore)().desktop)
        ? (_openBlock(), _createBlock(SubtotalMobileWidget, { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})